import { JOIN_FLOW_STEPS } from '@/lib/constants/maverick';
import { IJoinFaq } from './faqHelpers';

export const rafGiftFlowFaqs: Record<string, IJoinFaq> = {
  whatsIncludedRafGift: {
    hideIfTrial: true,
    pages: {
      [JOIN_FLOW_STEPS.JOIN]: true,
      [JOIN_FLOW_STEPS.MEMBERSHIP]: true,
      [JOIN_FLOW_STEPS.FAMILY]: false,
    },
    countries: {
      exclude: ['IN'],
    },
  },
  canGiftRecipientSwitch: {
    pages: {
      [JOIN_FLOW_STEPS.JOIN]: true,
      [JOIN_FLOW_STEPS.MEMBERSHIP]: false,
      [JOIN_FLOW_STEPS.FAMILY]: false,
    },
    countries: {
      exclude: ['IN'],
    },
  },
  doesGiftRecipientReturn: {
    pages: {
      [JOIN_FLOW_STEPS.JOIN]: true,
      [JOIN_FLOW_STEPS.MEMBERSHIP]: false,
      [JOIN_FLOW_STEPS.FAMILY]: false,
    },
    countries: {
      exclude: ['IN'],
    },
  },
  howShouldIDecideForGiftRecipient: {
    pages: {
      [JOIN_FLOW_STEPS.JOIN]: true,
      [JOIN_FLOW_STEPS.MEMBERSHIP]: false,
      [JOIN_FLOW_STEPS.FAMILY]: false,
    },
    countries: {
      exclude: ['IN'],
    },
  },
  willTheSameAccBeCompatibleOPL: {
    hideIfTrial: true,
    pages: {
      [JOIN_FLOW_STEPS.JOIN]: true,
      [JOIN_FLOW_STEPS.MEMBERSHIP]: true,
      [JOIN_FLOW_STEPS.FAMILY]: false,
    },
    countries: {
      exclude: ['IN'],
    },
  },
  isMyGiftRecipientsDataPrivate: {
    hideIfTrial: true,
    pages: {
      [JOIN_FLOW_STEPS.JOIN]: true,
      [JOIN_FLOW_STEPS.MEMBERSHIP]: true,
      [JOIN_FLOW_STEPS.FAMILY]: false,
    },
    countries: {
      exclude: ['IN'],
    },
  },
};

export const rafGiftFlowINFaqs: Record<string, IJoinFaq> = {
  whatsIncludedRafGiftIN: {
    hideIfTrial: true,
    pages: {
      [JOIN_FLOW_STEPS.JOIN]: true,
      [JOIN_FLOW_STEPS.MEMBERSHIP]: true,
      [JOIN_FLOW_STEPS.FAMILY]: false,
    },
  },
  canGiftRecipientSwitchIN: {
    pages: {
      [JOIN_FLOW_STEPS.JOIN]: true,
      [JOIN_FLOW_STEPS.MEMBERSHIP]: false,
      [JOIN_FLOW_STEPS.FAMILY]: false,
    },
  },
  doesGiftRecipientReturnIN: {
    pages: {
      [JOIN_FLOW_STEPS.JOIN]: true,
      [JOIN_FLOW_STEPS.MEMBERSHIP]: false,
      [JOIN_FLOW_STEPS.FAMILY]: false,
    },
  },
  howShouldIDecideForGiftRecipientIN: {
    pages: {
      [JOIN_FLOW_STEPS.JOIN]: true,
      [JOIN_FLOW_STEPS.MEMBERSHIP]: false,
      [JOIN_FLOW_STEPS.FAMILY]: false,
    },
  },
  willTheSameAccBeCompatibleOPLIN: {
    hideIfTrial: true,
    pages: {
      [JOIN_FLOW_STEPS.JOIN]: true,
      [JOIN_FLOW_STEPS.MEMBERSHIP]: true,
      [JOIN_FLOW_STEPS.FAMILY]: false,
    },
  },
  isMyGiftRecipientsDataPrivate: {
    hideIfTrial: true,
    pages: {
      [JOIN_FLOW_STEPS.JOIN]: true,
      [JOIN_FLOW_STEPS.MEMBERSHIP]: true,
      [JOIN_FLOW_STEPS.FAMILY]: false,
    },
  },
};
